const SCRIPT_TAG_RE = /<\s*script\b[^>]*>[\s\S]*?<\s*\/\s*script\s*>/gi;
const TAG_RE = /<\/?[a-z][^>]*>/gi;
const EVENT_HANDLER_RE = /\s+on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi;
const JS_URL_RE = /^\s*(javascript|data|vbscript)\s*:/i;

export function sanitizeText(value) {
  if (value == null) return value;
  if (typeof value !== "string") return value;
  return value
    .replace(SCRIPT_TAG_RE, "")
    .replace(EVENT_HANDLER_RE, "")
    .replace(TAG_RE, "");
}

export function sanitizeUrl(value) {
  if (typeof value !== "string") return value;
  return JS_URL_RE.test(value) ? "" : value;
}

function isPlainRecursable(v) {
  if (v === null || typeof v !== "object") return false;
  if (Array.isArray(v)) return true;
  const proto = Object.getPrototypeOf(v);
  return proto === Object.prototype || proto === null;
}

const DEFAULT_EXCLUDED_FIELDS = new Set([
  "password",
  "new_password",
  "current_password",
  "confirm_password",
  "confirmPassword",
  "newPassword",
  "currentPassword",
  "token",
  "access_token",
  "refresh_token",
  "otp",
  "code",
  "verification_code",
  "secret",
  "api_key",
]);

export function sanitizeFormValues(values, options = {}) {
  if (!values || typeof values !== "object") return values;
  const extra = options.exclude || [];
  const excluded = new Set([...DEFAULT_EXCLUDED_FIELDS, ...extra]);
  const out = Array.isArray(values) ? [] : {};
  for (const key of Object.keys(values)) {
    const v = values[key];
    if (excluded.has(key)) out[key] = v;
    else if (isPlainRecursable(v)) out[key] = sanitizeFormValues(v, options);
    else out[key] = sanitizeText(v);
  }
  return out;
}
